import { CTABannerItem } from './CTABannerItem/CTABannerItem'
import { useCTABannerItem } from './hooks/useCTABannerItem'
import { VisibleInField } from './types'

type Props = {
  visibleIn: VisibleInField
}

export const CTABanner = ({ visibleIn }: Props) => {
  const { bannerItemData } = useCTABannerItem({
    visibleIn,
  })
  if (!bannerItemData) {
    return null
  }
  return <CTABannerItem {...bannerItemData} />
}
